import httpClient from '@/core/http/client.service';
import { getRuntimeConfig } from '@/utils/env';

class Login {
  static verifyUser(username, password) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: '',
      },
    };

    const data = {
      name: username,
      pass: password,
    };

    return httpClient
      .post('/user/login?_format=json', data, config);
  }

  static async authenticate(username, password) {
    // const csrfToken = localStorage.getItem('csrf_token');

    const config = {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: '',
        // 'X-CSRF-Token': csrfToken,
      },
    };

    const runtimeConfig = await getRuntimeConfig();
    const bodyFormData = new FormData();

    bodyFormData.set('grant_type', 'password');
    bodyFormData.set('client_id', runtimeConfig.authClientId);
    bodyFormData.set('client_secret', runtimeConfig.authClientSecret);
    bodyFormData.set('username', username);
    bodyFormData.set('password', password);
    bodyFormData.set('scope', 'customer');

    return httpClient
      .post('/oauth/token', bodyFormData, config);
  }

  static logoutUser() {
    if (typeof window.acquire_logout_reload === "function") {
      window.acquire_logout_reload();
    }
    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: '',
      },
    };

    return httpClient
      .get('api/v1/user/logout?_format=json', config);
  }
}

export default Login;
